import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import noop from 'lodash/noop';
import { getCurrentBackgroundColor } from '../../utils/currentColors';
const Slider = (props) => {
    const { value = 0, minValue = 0, maxValue = Number.MAX_VALUE, valueLabels = false, valueLabelUnit, largeValueLabels = false, hideValueBar = false, color = 'primary', step = 1, onChange = noop, onDragEnd = noop, className, disabled = false } = props, remainingProps = __rest(props, ["value", "minValue", "maxValue", "valueLabels", "valueLabelUnit", "largeValueLabels", "hideValueBar", "color", "step", "onChange", "onDragEnd", "className", "disabled"]);
    const [currentValue, setCurrentValue] = useState(value ? value : minValue);
    const [isChanging, setIsChanging] = useState(false);
    useEffect(() => {
        if (value >= minValue && value <= maxValue) {
            setCurrentValue(value);
        }
    }, [value, minValue, maxValue]);
    const handleChange = (event) => {
        const newValue = Number.parseInt(event.target.value, 10);
        setCurrentValue(newValue);
        setIsChanging(true);
        onChange(newValue);
    };
    const onMouseUp = () => {
        setIsChanging(false);
        onDragEnd(currentValue);
    };
    const onMouseDown = () => {
        setIsChanging(true);
    };
    const wrapperClassNames = classNames('range-slider', disabled && 'disabled', valueLabels && 'show-value-labels', hideValueBar && 'hide-value-bar', largeValueLabels && 'large-value-labels', className && className);
    const trackWidth = (100 * (currentValue - minValue)) / (maxValue - minValue);
    const sliderBackgroundColor = getCurrentBackgroundColor(color);
    return (_jsxs("div", Object.assign({}, remainingProps, { className: wrapperClassNames, style: { color: sliderBackgroundColor } }, { children: [_jsx("div", { className: 'range-whole-track' }), _jsx("div", Object.assign({ className: 'range-track', style: { width: `${trackWidth}%` } }, { children: valueLabels && (_jsx("div", Object.assign({ className: 'range-value' }, { children: _jsx("span", { children: valueLabelUnit ? `${currentValue} ${valueLabelUnit}` : currentValue }) }))) })), _jsx("input", { className: `${isChanging ? 'changing' : ''}`, value: currentValue, min: minValue, max: maxValue, step: step, type: 'range', onChange: handleChange, onMouseDown: onMouseDown, onMouseUp: onMouseUp })] })));
};
export default Slider;
